import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { StoreContext } from "../../../Store/Provider";
import PieChart from "./PieChart";
import LineChart from "./Line";
import BarChart from "./BarChart";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Drawer from "@material-ui/core/Drawer";
import Sidebar from "../Home/Sidebar/Sidebar";
import Header from "../Home/Header/Header";
import PropagateLoader from "react-spinners/PropagateLoader";
import "./dashboard.css";
import BoxSVG from "../../SVG/Box";
import Truck from "../../SVG/Truck";
import SemiDoughnutChart from "./SemiDoughnutChart";
import AdvSearchSvg from "../../SVG/AdvSearch";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import AdvanceSearchDahboard from "./AdvanceSearchDashboard";
import DoughnutChart from "./DoughnutChart";
import { HOST_URL } from "../../../Config";
import BarStats from "./BarStats";
import { getUserData, localStoragekey } from "../../Common/Utility/Utils";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Dashboard() {
  const classes = useStyles();
  const context = useContext(StoreContext);
  const [invoiceData, setInvoiceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statics, setStatics] = useState({});
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [modalOpen, setModalOpen] = React.useState(false);
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (!context.dashboardData.loaded) {
      getDashboardData();
    } else {
      dataForGraphs(context.dashboardData.data);
    }
  }, []);

  const getDashboardData = async (
    TransportMode = "",
    ContainerMode = "",
    EstimatedArrival = "",
    EstimatedDeparture = ""
  ) => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    setLoading(true);
    let END_POINT = `${HOST_URL}api/v1/Shipment/KPI`;
    const params = {
      TransportMode: TransportMode,
      EstimatedArrival: EstimatedArrival,
      EstimatedDeparture: EstimatedDeparture,
      ContainerMode: ContainerMode,
    };
    axios
      .post(END_POINT, params, {
        headers: header,
      })
      .then((res) => {
        if (res.data.Success) {
          context.setDashboardData({ loaded: true, data: res.data.Value });
        }
        dataForGraphs(res.data.Value);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        context.setDashboardData({ loaded: false, data: [] });
        setOpen(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const dataForGraphs = (data) => {
    let stats = {};
    if (data) {
      stats.totalInvoice = data.invoiceKPI.total;
      stats.totalInvoiceCurrency = data.invoiceKPI.currency;
      stats.Intransit = data.shipmentStatusKPI.Intransit;
      stats.Arrived = data.shipmentStatusKPI.Arrived;
      stats.Total = data.shipmentCountKPI.Total;
      stats.Air = data.shipmentCountKPI.Air;
      stats.Sea = data.shipmentCountKPI.Sea;
      stats.shipmentTM = data.shipmentTM;
      stats.TotalShipments = data.shipmentTVWKPI.total;
      stats.Volume = data.shipmentTVWKPI.volume;
      stats.Quantity = data.shipmentTVWKPI.weight;
      stats.shipmentCountKPI = data.shipmentCountKPI;
      stats.shipmentStatKPI = data.shipmentStatKPI;
      stats.arrivalOnTimeKPI = data.arrivalOnTimeKPI;
      stats.avgTransitTypeKPI = data.avgTransitTypeKPI;
      stats.shipmentTypeKPI = data.shipmentTypeKPI;
      setInvoiceData(data.invoiceKPIMonthly);
    }

    setStatics(stats);
    setLoading(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    borderRadius: "1rem",
    p: 2,
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main
          className={clsx(classes.content, {
            [classes.contentunshift]: !context.menuBar,
            [classes.contentShift]: context.menuBar,
          })}
        >
          {loading ? (
            <div className="loadingClass">
              <PropagateLoader
                color={"rgba(var(--text-heading-dark))"}
                size={"1.5rem"}
              />
            </div>
          ) : (
            <div className="dashBody">
              <div className="dashBodyHeading">
                <div className="uRFirst">
                  <h6 className="graphTitle">Total Invoice Amount</h6>
                  <div className="urThirdUpper">
                    {statics.totalInvoiceCurrency}
                    {context.calculateAmmount(statics.totalInvoice)} k
                  </div>
                </div>
                <div className="uRSecond">
                  <h6 className="graphTitle">Loaded - In Transit</h6>
                  <div className="urThirdLower">
                    <div>
                      <Truck colorCode={"rgba(var(--text-heading-light))"} />
                      <br />
                      <span>{statics.Intransit}</span>
                    </div>
                  </div>
                </div>
                <div className="uRThird">
                  <h6 className="graphTitle">Delivered</h6>
                  <div className="urThirdLower">
                    <div>
                      <BoxSVG colorCode={"rgba(var(--text-heading-light))"} />
                      <br />
                      <span>{statics.Arrived}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboardUpperRow">
                <div className="uRFirst">
                  <h6 className="graphTitle">
                    Invoice Amount (Values in thousand)
                  </h6>
                  <div className="graphLowerportionDiv">
                    <BarChart type="transit" data={invoiceData} />
                  </div>
                </div>
                <div className="uRSecond">
                  <h6 className="graphTitle">Shipping Type</h6>
                  <div className="graphLowerportionDiv p-2">
                    <PieChart data={statics.shipmentTypeKPI} />
                  </div>
                </div>
                <div className="uRThird">
                  <h6 className="graphTitle">Total Shipments</h6>
                  <div className="urThirdUpper">
                    <SemiDoughnutChart data={statics.shipmentTM} />
                  </div>
                </div>
              </div>
              <div className="dashboardLowerRow">
                <div className="lRFirst">
                  <h6 className="graphTitle">Shipment Stats</h6>
                  <div className="grapTitleDiv">
                    <div>
                      <span>Total Shipment</span>
                      <p>{statics.TotalShipments}</p>
                    </div>
                    <div>
                      <span>Quantity</span>
                      <p>{statics.Quantity} kg</p>
                    </div>
                    <div>
                      <span>Volume</span>
                      <p>
                        {statics.Volume} m<sup>3</sup>
                      </p>
                    </div>
                  </div>
                  <div className="graphLowerportionDiv">
                    <BarStats type="stats" data={statics.shipmentStatKPI} />
                  </div>
                </div>
                <div className="lRSecond">
                  <h6 className="graphTitle">Average Transit Time</h6>
                  <p className="graphPara">
                    No. of shipments v/s transit time in weeks
                  </p>
                  <div className="graphLowerportionDiv">
                    <LineChart data={statics.avgTransitTypeKPI} />
                  </div>
                </div>
                <div className="lRThird">
                  <h6 className="graphTitle">Arrival on time</h6>
                  <p className="graphPara">
                    Based on estimated arrival v/s actual vessel discharge date
                  </p>
                  <div className="graphLowerportionDiv p-2">
                    <DoughnutChart data={statics.arrivalOnTimeKPI} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
      <div
        className="advSearch advSearchDashBoard pointer "
        onClick={handleOpenModal}
      >
        <AdvSearchSvg colorCode={"#fff"} />
      </div>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box sx={style} className="advSearchModalContainer">
          <div className="advSearchModalContainerHeading mb-3">
            <h5>Filters</h5>
            <CloseIcon className="pointer" onClick={handleCloseModal} />
          </div>
          <AdvanceSearchDahboard
            close={handleCloseModal}
            apiCall={getDashboardData}
          />
        </Box>
      </Modal>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentunshift: {
    width: "calc(100% - 2.5rem)",
  },
  contentShift: {
    width: "calc(100% - 16rem)",
  },
  drawerLeft: {
    width: "16rem",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default Dashboard;
